$(function () {
  var s = [];
  $(".single-post__text h2").each(function (i) {
    $(this).attr("id", "section" + i), (s[i] = $(this).html());
  });
  var i = $(".single-post__text h2").length;
  for (let e = 0; e < i; e++)
    $(".single-post__navigation ul").append(
      "<li><a href='#section" + e + "'>" + s[e] + "</a></li>"
    );
  $(".single-post__navigation li:first-child a").addClass("active"),
    $(".single-post__navigation a").click(function () {
      $(".single-post__navigation a").removeClass("active"),
        $(this).addClass("active"),
        event.preventDefault(),
        $("html,body").animate(
          { scrollTop: $(this.hash).offset().top - 25 },
          500
        );
    }),
    $(".js-new-product-slider").slick({
      infinite: !0,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: !1,
      autoplay: !0,
      swipeToSlide: !0,
      variableWidth: !0,
      autoplaySpeed: 3e3,
      speed: 1e3,
      dots: !1,
      responsive: [
        { breakpoint: 9999, settings: "unslick" },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: !1,
            dots: !1,
          },
        },
      ],
    }),
    $(".js-trending-slider").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !1,
      autoplay: !0,
      swipeToSlide: !0,
      autoplaySpeed: 3e3,
      variableWidth: !0,
      dots: !1,
      speed: 500,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 3, slidesToScroll: 1, dots: !1 },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: !1,
            dots: !1,
          },
        },
      ],
    }),
    $(".js-trending-button-prev").click(function () {
      $(".js-trending-slider").slick("slickPrev");
    }),
    $(".js-trending-button-next").click(function () {
      $(".js-trending-slider").slick("slickNext");
    }),
    $(".js-related-post-slider").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: !0,
      autoplay: !0,
      swipeToSlide: !0,
      autoplaySpeed: 3e3,
      dots: !1,
      speed: 500,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: !0,
            arrows: !1,
          },
        },
        { breakpoint: 767, settings: "unslick" },
      ],
    });
}),
  $(function () {
    var s = 0;
    $(window).scroll(function (i) {
      var e = $(this).scrollTop();
      Math.abs(s - e) <= 15 ||
        ((e > s && s > 0) || $("header").css("top", "0px"), (s = e));
    });
  }),
  $(window)
    .scroll(function () {
      var s = $(window).scrollTop();
      $(".single-post__text h2").each(function (i) {
        $(this).position().top <= s &&
          ($(".single-post__navigation a.active").removeClass("active"),
          $(".single-post__navigation a").eq(i).addClass("active"));
      });
    })
    .scroll();
